export function listenToSelectTagDropdownClick() {
  document.querySelectorAll(".btn-open-select").forEach(dropdown =>
    dropdown.addEventListener('click', toggleSelectProjectDropdown))
}

function toggleSelectProjectDropdown(e) {
  const select = e.currentTarget
  const selectContainerId = select.dataset.selectContainerId
  const dropdown = document.getElementById(`collapsible-container-${selectContainerId}`)
  const icon = select.querySelector('i')

  const doCollapse = !dropdown.classList.contains('collapsed-x')

  console.log('do collapse on', doCollapse, selectContainerId)

  icon.classList.toggle('rotate-n90')

  if (doCollapse) {
    dropdown.addEventListener(
      'transitionend',
      () => dropdown.classList.add('collapsed-x'),
      { once: true }
    )
    dropdown.classList.add('collapsed-y-30px')
  }
  else {
    dropdown.addEventListener(
      'transitionend',
      () => setTimeout(() => dropdown.classList.remove('collapsed-y-30px'), 100),
      { once: true }
    )
    dropdown.classList.remove('collapsed-x')
  }
}